class SharedFeatureFlagModel

  isEnabled: (key) ->
    window.evaluate(window.featureFlagJSON?[key])

  isRedesignOrdersUSEnabled: ->
    @isEnabled("redesignOrdersUS")

  isShowLiveChatEnabled: ->
    @isEnabled("showLiveChat")

  isShowMerchantInfoFieldsEnabled: ->
    @isEnabled("showMerchantInfoFields")

  isShowUserContactInfoFieldsEnabled: ->
    @isEnabled("showUserContactInfoFields")

  isSearchBasedDropDownsEnabled: ->
    @isEnabled("searchBasedDropDowns")

module.exports = SharedFeatureFlagModel
